import React, { useEffect, useRef } from 'react';
import * as PIXI from 'pixi.js';
import { Spine } from 'pixi-spine';
import { Container } from '@pixi/react';
import { useSelector } from 'react-redux';
import { getAsset } from '../../assets';

const SpineAnimation = ({
  animationPath,
  animationName,
  x,
  y,
  zIndex,
  width,
  height,
}) => {
  const { status } = useSelector((state) => state.assets);
  const spineRef = useRef(null);

  useEffect(() => {
    const loadSpineAnimation = async () => {
      try {
        const spineResource = getAsset(status, animationPath);

        if (!spineResource || !spineResource.spineData) {
          console.warn('Spine resource or data is missing!');
          return;
        }

        // Create a new Spine animation
        const spineAnim = new Spine(spineResource.spineData);

        // Set the animation if it exists
        if (spineAnim.state.hasAnimation(animationName)) {
          spineAnim.state.setAnimation(0, animationName, true);
        }

        // Position the animation
        spineAnim.position.set(0, 0);

        if (width) {
          spineAnim.width = width;
        }

        if (height) {
          spineAnim.height = height;
        }

        spineRef.current.addChild(spineAnim);
      } catch (error) {
        console.error('Error loading Spine animation:', error);
      }
    };

    if (!spineRef.current) {
      spineRef.current = new PIXI.Container();
      spineRef.current.zIndex = zIndex;
    }

    loadSpineAnimation();

    return () => {
      if (spineRef.current) {
        spineRef.current.destroy();
        spineRef.current = null;
      }
    };
  }, []);

  return (
    <Container
      ref={spineRef}
      zIndex={zIndex}
      name="Spine Animation"
      sortChildren={true}
      x={x}
      y={y}
    ></Container>
  );
};

export default SpineAnimation;
